import { Component, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification.service';
import { Eshop } from 'src/typings';
import { EshopService } from '../eshop.service';

@Component({
  selector: 'app-eshop-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent {
  doneEvent: EventEmitter<Eshop> = new EventEmitter();

  createForm = this.fb.group({
    description: new UntypedFormControl()
  });

  constructor(
    private fb: UntypedFormBuilder,
    private eshopService: EshopService,
    private notificationService: NotificationService
  ) {}

  async create() {
    const res = await this.eshopService
      .create({
        description: this.createForm.value.description
      })
      .toPromise();
    this.notificationService.notice(`Магазин ${this.createForm.value.description} создан!`);
    this.doneEvent.emit(res);
    return;
  }
}
